import React from 'react';
import { Icon } from 'components/ui';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { hideBanner } from '../../../actions/journeyBuilder';

const JourneyBanner = ({ message, state = 'success' }) => {
  const dispatch = useDispatch();

  const { previewing, bannerDismissible } = useSelector(
    reduxState => reduxState.ui,
  );

  const journeyBannerClassName = classNames(
    `JourneyBanner JourneyBanner--${state} mt-0`,
    {
      'JourneyBanner-editing': !previewing,
    },
  );

  return (
    <div className={journeyBannerClassName}>
      <div className="JourneyBanner-left mt-0 d-f fd-r ai-c">
        <div>
          <span className="JourneyBanner-icon">
            {state === 'success' ? (
              <Icon name="check_mark" />
            ) : (
              <Icon name="warning_sign" />
            )}
          </span>
        </div>
        <div className="ml-4">
          <span className="JourneyBanner-message">{message}</span>
        </div>
      </div>
      {bannerDismissible && (
        <div className="JourneyBanner-right mt-0">
          <button
            type="button"
            className="JourneyBanner-dismissButton"
            onClick={() => {
              dispatch(hideBanner());
            }}
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
};

export default JourneyBanner;
